import {Basic} from 'types'
import * as Actions from './actions'
import {Action} from './types'

export const reducer = (userInput: Basic.CartItemInput, action: Action): Basic.CartItemInput => {
  switch (action.type) {
    case 'setOptionId':
      return Actions.setOptionId(userInput, action.optionId, action.stepOrder)
    case 'setDate':
      return Actions.setDate(userInput, action.date, action.stepOrder)
    case 'setAvailabilityId':
      return Actions.setAvailabilityId(userInput, action.availabilityId, action.stepOrder)
    case 'setUnitCounters':
      return Actions.setUnitCounters(userInput, action.unitCounters, action.stepOrder)
  }
}
